import { __awaiter, __generator, __read } from "tslib";
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { sanitizeUrlParameter } from '@office-start/url-parser-utility';
import { logClick } from './operations/logClick';
import { isOfficeRouteItem } from './utilities/isOfficeRouteItem';
var getFeatures = function (launchUrlParams) {
    var frame;
    var left = launchUrlParams.left, top = launchUrlParams.top, width = launchUrlParams.width, height = launchUrlParams.height;
    if (left && top) {
        frame = "left=".concat(left, ",top=").concat(top);
    }
    // Sizing specifications
    if (width && height) {
        frame = (frame ? "".concat(frame, ",") : '') + "width=".concat(width, ",height=").concat(height);
    }
    return frame;
};
var resolveLaunchParams = function (launchUrlParams, defaultLinkTarget) {
    if (defaultLinkTarget === void 0) { defaultLinkTarget = '_blank'; }
    if (!launchUrlParams) {
        return [undefined, defaultLinkTarget, window];
    }
    var linkTarget = launchUrlParams.linkTarget, targetTab = launchUrlParams.targetTab;
    return [
        getFeatures(launchUrlParams),
        linkTarget !== null && linkTarget !== void 0 ? linkTarget : defaultLinkTarget,
        targetTab !== null && targetTab !== void 0 ? targetTab : window,
    ];
};
var getResult = function (openResult, linkTarget) {
    if (openResult === null) {
        return 'OpenNull';
    }
    else if (openResult === undefined) {
        return 'OpenUndefined';
    }
    return linkTarget === '_blank' ? 'NewTab' : 'Inline';
};
export var defaultLaunchUrl = function (urlOrRoute, launchUrlParams, launchInstrumentationParams, officeRouteParams) { return __awaiter(void 0, void 0, void 0, function () {
    var success, result, message, router, _a, features, target, openWindow, openResult;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                success = false;
                message = 'defaultLaunchUrl';
                // For sway creation in Create page, return if url is falsy
                if (!urlOrRoute) {
                    return [2 /*return*/, { message: message, result: result, success: success }];
                }
                if (!isOfficeRouteItem(urlOrRoute)) return [3 /*break*/, 3];
                return [4 /*yield*/, fetchOfficeComponentContext()];
            case 1:
                router = (_b.sent()).router;
                return [4 /*yield*/, router.navigateTo(urlOrRoute, false /* replace */, officeRouteParams)];
            case 2:
                success = _b.sent();
                result = 'Inline';
                message += ".navigateTo:".concat(success);
                return [3 /*break*/, 4];
            case 3:
                _a = __read(resolveLaunchParams(launchUrlParams), 3), features = _a[0], target = _a[1], openWindow = _a[2];
                openResult = openWindow.open(sanitizeUrlParameter(urlOrRoute), target, features);
                success = !!openResult;
                message += ".open:".concat(success);
                result = getResult(openResult, target);
                _b.label = 4;
            case 4:
                // Note:  router.navigateTo() can return null for Angular Router's navigate() calls that
                // did not result in a navigation (e.g. same URL with onSameUrlNavigation === 'ignore').
                // (https://github.com/angular/angular/blob/99898f33703e46b7fec81babe83701705519af9e/packages/router/src/router.ts#L602)
                // In that case, we'll skip logging the click event since there was technically no referral.
                if (success !== null) {
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: success,
                        platform: 'Web',
                    });
                }
                return [2 /*return*/, { message: message, result: result, success: success }];
        }
    });
}); };
//# sourceMappingURL=defaultLaunchUrl.js.map